module.exports = __webpack_public_path__ + "img/twitterhover.70d575f3.svg";